import { Chart } from '@frontend/chart/types';

export const PUDO_TRANSACTION_VOLUME_BY_SENDER_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'Anna Vermeulen', data: [{ label: 'full_period', value: 42 }] },
        { name: 'Thomas De Smet', data: [{ label: 'full_period', value: 36 }] },
        { name: 'Sarah Peeters', data: [{ label: 'full_period', value: 28 }] },
        { name: 'Lucas Janssens', data: [{ label: 'full_period', value: 21 }] },
        { name: 'Emma Claes', data: [{ label: 'full_period', value: 17 }] },
        { name: 'Noah Wouters', data: [{ label: 'full_period', value: 12 }] }
    ]
};
